import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import { GET_FLAT_OBJECT_PROPERTIES } from 'automation-ui-enrollment/queries/ObjectPropertiesQueries';
const DEFAULT_UNIQUE_PROPERTIES = ['hs_object_id'];
const BUILT_IN_UNIQUE_PROPERTIES_BY_OBJECT = {
  '0-1': [...DEFAULT_UNIQUE_PROPERTIES, 'email']
};
const useUniquePropertiesForObjectType = objectTypeId => {
  const {
    data,
    loading,
    error,
    refetch
  } = useQuery(GET_FLAT_OBJECT_PROPERTIES, {
    variables: {
      objectTypeId: objectTypeId
    },
    skip: !objectTypeId
  });
  const uniqueProperties = useMemo(() => {
    const builtInUniqueProperties = BUILT_IN_UNIQUE_PROPERTIES_BY_OBJECT[objectTypeId] || DEFAULT_UNIQUE_PROPERTIES;
    if (data) {
      return data.flatProperties.filter(({
        property
      }) => builtInUniqueProperties.includes(property.name) || !property.hidden && property.hasUniqueValue).sort(({
        property: property1
      }, {
        property: property2
      }) => property1.name.localeCompare(property2.name));
    }
    return [];
  }, [data, objectTypeId]);
  return {
    data: uniqueProperties,
    loading,
    error,
    refetch
  };
};
export default useUniquePropertiesForObjectType;